export default function TextContainerElement(target) {
  this.print = (text) => {
    target.innerText = text;
  };
  this.clear = () => {
    this.print('');
  };
}
